import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { ConfigConstants } from '@evorait/pace-core';

@Directive({
    selector: '[paceSwipe]',
})
export class SwipeDirective {
    @Output() public swipeLeft = new EventEmitter<string>();
    @Output() public swipeRight = new EventEmitter<string>();

    private touchStartX: number;
    private touchStartY: number;
    private touchEndX: number;
    private touchEndY: number;
    private isTextSelectionActive = false;
    @HostListener('touchstart', ['$event'])
    public onTouchStart(event: TouchEvent): void {
        if (this.isTextSelectionActive) return;
        this.touchStartX = event.changedTouches[0].screenX;
        this.touchStartY = event.changedTouches[0].screenY;
    }

    @HostListener('touchend', ['$event'])
    public onTouchEnd(event: TouchEvent): void {
        if (this.isTextSelectionActive) return;
        this.touchEndX = event.changedTouches[0].screenX;
        this.touchEndY = event.changedTouches[0].screenY;
        this.handleSwipeGesture();
    }

    @HostListener('document:selectionchange')
    public onSelectionChange(): void {
        const selection = window.getSelection();
        if (selection && selection.type === 'Range') {
            this.isTextSelectionActive = true; // Active text selection
        } else {
            this.isTextSelectionActive = false; // No text selection
        }
    }

    private handleSwipeGesture(): void {
        const deltaX = this.touchEndX - this.touchStartX;
        const deltaY = this.touchEndY - this.touchStartY;
        const threshold = 10; // Minimum movement required to register a swipe
        const verticalTolerance = 25; // Allowable vertical movement for a horizontal swipe

        // Ignore if vertical movement is too high
        if (Math.abs(deltaY) < verticalTolerance) {
            // Horizontal swipe
            if (deltaX > threshold) {
                this.swipeRight.emit(ConfigConstants.SWIPE_ACTION.RIGHT);
            } else if (deltaX < threshold * -1) {
                this.swipeLeft.emit(ConfigConstants.SWIPE_ACTION.LEFT);
            }
        }
    }
}
